import * as yup from "yup";

export const PASSWORD_EDIT_FORM_SCHEMA = yup.object().shape({
  password: yup
    .string()
    .nullable()
    .required("Molimo unesite lozinku")
    .min(6, "Lozinka mora imati barem 6 znakova"),
  confirmPassword: yup
    .string()
    .nullable()
    .required("Molimo potvrdite lozinku")
    .oneOf([yup.ref("password")], "Lozinke se ne podudaraju"),
});
